import clsx from 'clsx';
import React, { ElementType } from 'react';
import classes from './PageContentWrapper.module.scss';

export type Props<T extends ElementType = 'div'> = {
  component?: T;
  children: React.ReactNode;
  className?: string;
  horizontal?: boolean;
  fullPageWidth?: boolean;
  noMarginBottomMobile?: boolean;
} & React.ComponentProps<T>;

const PageContentWrapper: React.FC<Props> = ({
  component,
  children,
  className,
  horizontal,
  fullPageWidth,
  noMarginBottomMobile,
}) => {
  const Root = (component || 'div') as React.ElementType;
  return (
    <Root
      className={clsx(
        classes.root,
        !fullPageWidth && classes.spaced,
        noMarginBottomMobile && classes.noMarginBottomMobile,
        horizontal && classes.horizontal,
        className,
      )}
    >
      {children}
    </Root>
  );
};

export default PageContentWrapper;
